import type { ReactNode } from 'react';
import { PageHeader } from '../../PageHeader.js';
import classes from './Settings.module.css';

/**
 * Ayarlar ekranı (M6f G6-32, G6-33): web ofiste ve gemide aynı düzen. Ana sütunda dil, hesap ve
 * uygulamaya özgü kart (gemide senkron, ofiste şirket markası); ≈ 360 px özet sütununda gemide
 * "This Computer" ve iki tarafta "Software". 1279 px ve altında özet sütunu içeriğin altına iner.
 */
export function SettingsLayout({
  title,
  description,
  main,
  aside,
}: {
  title: string;
  description: string;
  main: ReactNode;
  aside: ReactNode;
}) {
  return (
    <div className={classes.page}>
      <PageHeader title={title} description={description} />
      <div className={classes.grid}>
        <div className={classes.column}>{main}</div>
        <div className={classes.column}>{aside}</div>
      </div>
    </div>
  );
}

/** Etiketli satırlar (`<dl>`): ortak etiket sütunu 160 px (M6f G6-31). */
export function Facts({ children, compact = false }: { children: ReactNode; compact?: boolean }) {
  return (
    <dl className={classes.facts} data-compact={compact || undefined}>
      {children}
    </dl>
  );
}

export function Fact({
  label,
  help,
  children,
}: {
  label: ReactNode;
  /** Değerin altında açıklama. */
  help?: ReactNode;
  children: ReactNode;
}) {
  return (
    <>
      <dt>{label}</dt>
      <dd>
        {children}
        {help ? <span className={classes.factHelp}>{help}</span> : null}
      </dd>
    </>
  );
}

/** Kartın altında sağa yaslı eylemler (M6f G6-38). */
export function CardFooter({ children }: { children: ReactNode }) {
  return <div className={classes.footer}>{children}</div>;
}

/** Kod ya da parmak izi: açık zeminli çip ve isteğe bağlı kopyala düğmesi (M6f G6-37). */
export function CodeChip({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <span className={classes.chip}>
      <span>{children}</span>
      {action}
    </span>
  );
}

export const settingsClasses = classes;
